import { useEffect } from 'react';
import ProjectCardBySkill from './ProjectCardBySkill';
import ProjectCardSkeleton from './ProjectCardSkeleton';
import DotPagination from './DotPagination';

export interface Project {
    project_id: number;
    project_name: string;
    skill_name?: string;
    climb_type?: string;
    employee_goal_count: number;
    employee_actual_hours: number;
}

interface Pagination {
    total_pages: number;
    current_page: number;
    total_items: number;
    has_next: boolean;
    has_previous: boolean;
}

interface ProjectsBySkillSectionProps {
    projects: Project[];
    selectedSkill: string | null;
    loading: boolean;
    error: any;
    pagination: Pagination | null;
    currentPage: number;
    onPageChange: (page: number) => void;
    labelType?: string;
}

const ProjectsBySkillSection = ({ projects, selectedSkill, loading, error, pagination, currentPage, onPageChange, labelType = 'Skill' }: ProjectsBySkillSectionProps) => {
    // Reset to first page when selected skill changes
    useEffect(() => {
        onPageChange(1);
    }, [selectedSkill, onPageChange]);

    return (
        <div className="bg-surface-bg-primary rounded-lg p-6 border border-surface-border">
            <div className="flex items-center gap-2 mb-4 justify-between">
                <h3 className="text-lg font-semibold">Projects</h3>
                {selectedSkill && (
                    <span className="text-xs px-2 py-1 rounded bg-main-blue text-white btn-goal-project">
                       + {selectedSkill}
                    </span>
                )}
            </div>
            {loading ? (
                <div className="flex flex-col gap-3">
                    <ProjectCardSkeleton />
                    <ProjectCardSkeleton />
                    <ProjectCardSkeleton />
                </div>
            ) : error ? (
                <div className="text-center py-8 text-danger-active">
                    Error loading projects
                </div>
            ) : projects.length === 0 ? (
                <div className="text-center py-8 text-text-text-secondary">
                    No projects found for this skill
                </div>
            ) : (
                <>
                    <div className="flex flex-col gap-3">
                        {projects.map((project) => (
                            <ProjectCardBySkill
                                key={project.project_id}
                                projectName={project.project_name}
                                employeeGoalCount={project.employee_goal_count}
                                employeeActualHours={project.employee_actual_hours}
                            />
                        ))}
                    </div>
                    {pagination && pagination.total_pages > 1 && (
                        <DotPagination
                            totalPages={pagination.total_pages}
                            currentPage={currentPage - 1}
                            onPageChange={(page) => onPageChange(page + 1)}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default ProjectsBySkillSection;
